// src/services/credentialStatus.js
//
// A staff credential's status from its expiry date (DDMMMYYYY, e.g. 05MAR2027).
// Moved here unchanged from NotificationsPage (2026-11-02) so the Notifications
// page and the home page's snippet use one rule. The strings are what the
// Notifications page shows; keep them as they are.

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const checkStatus = (dateStr) => {
  if (!dateStr || dateStr === "N/A") return "ℹ️ Not Required";

  const date = dayjs(dateStr.trim(), "DDMMMYYYY", true);
  const today = dayjs();
  const diffDays = date.diff(today, "day");

  if (!date.isValid()) return "❌ Invalid Date";
  if (diffDays < 0) return "❌ Expired – Urgent action required";
  if (diffDays === 0) return "⚠️ Expiring tomorrow";
  if (diffDays <= 30) return "⚠️ Expiring within 1 month";
  if (diffDays <= 183) return "⚠️ Expiring within 6 months";
  return "✅ Valid";
};

/** The credentials the Notifications page lists for each employee, in its order. */
export const CREDENTIAL_FIELDS = [
  { field: "CV_EXP", label: "CV" },
  { field: "GCP_EXP", label: "GCP" },
  { field: "IATA_EXP", label: "IATA" },
  { field: "ML_EXP", label: "Medical License" },
  { field: "CPR_EXP", label: "CPR" },
  { field: "CITI_EXP", label: "CITI" },
];

/** A status that needs attention (the Notifications page hides Valid and Not Required). */
export const needsAttention = (status) => status !== "✅ Valid" && status !== "ℹ️ Not Required";

/** How urgent a status is, as the Notifications page ranks it: 3 most urgent, 0 not at all. */
export const statusSeverity = (status) => {
  if (status.startsWith("❌") || status.includes("Expiring tomorrow")) return 3;
  if (status.includes("within 1 month")) return 2;
  if (status.includes("within 6 months")) return 1;
  return 0;
};
